import React from 'react';
import { Box, Typography } from '@mui/material';

const TeamSettingsHeader = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
                Team Settings
            </Typography>
        </Box>
    );
};

export default TeamSettingsHeader;

